import createRoute from './createRoute';

const HOME_ROUTE = createRoute({
  name: 'Home-Text',
  path: '',
  childRoutes: [],
});

const LANDBASED_ROUTE = createRoute({
  name: 'Header-Menu-Subpage-Landbased',
  path: 'products/land-based',
  childRoutes: [],
});

const PRODUCTS_ROUTE = createRoute({
  name: 'Header-Menu-Products',
  path: 'products',
  isNotUrl: true,
  childRoutes: [
    {
      name: 'Header-Menu-Subpage-Games',
      path: 'games/all',
      childRoutes: [],
    },
    {
      name: 'Header-Menu-Subpage-Landbased',
      path: 'land-based',
      childRoutes: [],
    },
    {
      name: 'rico-series',
      path: '../rico-series',
      childRoutes: [],
    },
    {
      name: 'Header-Menu-Poly',
      path: '../poly',
      childRoutes: [],
    },
  ],
});

const BLOG_ROUTE = createRoute({
  name: 'Header-Menu-Blog',
  path: 'blog',
  isNotUrl: true,
  hideParentUrl: true,
  childRoutes: [
    {
      name: 'Header-Menu-Subpage-Blog',
      path: 'blog',
      childRoutes: [],
    },
    {
      name: 'Header-Menu-Subpage-News',
      path: 'news',
      childRoutes: [],
    },
    {
      name: 'Header-Menu-Subpage-Upcoming events',
      path: 'upcoming-events',
      childRoutes: [],
    },
  ],
});

const GAMES_ROUTE = createRoute({
  name: 'LandBased-Section Headers-Menu-Games',
  path: 'products/games',
  childRoutes: [
    {
      name: 'Games-Section Headers-Menu-All',
      path: 'all',
      childRoutes: [],
    },
    {
      name: 'Games-Section Headers-Menu-Slots',
      path: 'slots',
      childRoutes: [],
    },
    {
      name: 'Games-Section Headers-Menu-LiveCasino',
      path: 'live-casino',
      childRoutes: [],
    },
    {
      name: 'Games-Section Headers-Menu-Instant Games',
      path: 'instant-games',
      childRoutes: [],
    },
    {
      name: 'Games-Section Headers-Menu-Crash Games',
      path: 'crash-games',
      childRoutes: [],
    },
  ],
});

export const NEWS_ROUTE = createRoute({
  name: 'NEWS',
  path: 'news',
  childRoutes: [],
});
export const UPCOMING_EVENTS = createRoute({
  name: 'upcoming-events',
  path: 'upcoming-events',
  childRoutes: [],
});

const ABOUT_US_ROUTE = createRoute({
  name: 'Header-Menu-About us',
  path: 'about-us',
  childRoutes: [],
});

const CONTACT_US_ROUTE = createRoute({
  name: 'Header-Menu-Contact us',
  path: 'contact-us',
  childRoutes: [],
});

const BADALYANS_AI_ROUTE = createRoute({
  name: 'BADALYANS_AI',
  path: 'badalyans-ai',
  childRoutes: [],
});

const POLY_ROUTE = createRoute({
  name: 'Header-Menu-Poly',
  path: 'poly',
  childRoutes: [],
});

const CLIENT_AREA = createRoute({
  name: 'Client Area',
  path: 'https://clienthub.popokgaming.com/',
  childRoutes: [],
});



const AVI_ROUTE = createRoute({
  name: 'Header-Menu-Avi',
  path: 'avi',
  childRoutes: [],
});

export {
  HOME_ROUTE,
  BLOG_ROUTE,
  PRODUCTS_ROUTE,
  ABOUT_US_ROUTE,
  LANDBASED_ROUTE,
  CONTACT_US_ROUTE,
  BADALYANS_AI_ROUTE,
  POLY_ROUTE,
  AVI_ROUTE,
  GAMES_ROUTE,
  CLIENT_AREA
};
